import { makeMaskedNumbersScreenReadable } from '../StopService/utils';

interface DisplayAddressProps {
  apt?: string;
  houseNum?: string;
  streetName?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

export const DisplayAddress = ({ apt, houseNum, streetName }: DisplayAddressProps) => {
  return (
    <>
      <span aria-hidden="true" className="block capitalize pii">
        {houseNum?.toLowerCase()} {streetName?.toLowerCase()}
        {apt ? `, ${apt}, ` : ' '}
      </span>
      <span className="sr-only">{`service address: starting in ${makeMaskedNumbersScreenReadable(
        houseNum
      )} ${streetName?.toLowerCase().substring(0, 4)} `}</span>
    </>
  );
};
